/* DoorGlow announcement bar: rotates one message at a time.
   Pauses while hovered or focused. With reduced motion the CSS swaps by fading
   instead of sliding, and messages stay up longer. */
if (!customElements.get('dg-announce')) {
  customElements.define('dg-announce', class extends HTMLElement {
    connectedCallback() {
      this.msgs = [...this.querySelectorAll('.dg-announce__msg')];
      if (this.msgs.length < 2) return;
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 5000;
      this.paused = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelectorAll('.dg-announce__nav').forEach((btn) =>
        btn.addEventListener('click', () => {
          // Announce messages the shopper asked for, not the automatic rotation
          this.querySelector('.dg-announce__track').setAttribute('aria-live', 'polite');
          this.go(this.index + Number(btn.dataset.dir));
          this.restart();
        })
      );
      const pause = () => { this.paused = true; };
      const resume = () => { this.paused = false; };
      this.addEventListener('mouseenter', pause);
      this.addEventListener('mouseleave', resume);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', resume);
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.restart()));
      this.restart();
    }

    disconnectedCallback() { this.stop(); }

    stop() { clearInterval(this.timer); }

    restart() {
      this.stop();
      const interval = this.reduced ? Math.max(this.interval, 7000) : this.interval;
      this.timer = setInterval(() => { if (!this.paused) this.go(this.index + 1); }, interval);
    }

    go(next) {
      const count = this.msgs.length;
      next = (next + count) % count;
      if (next === this.index) return;
      const prev = this.msgs[this.index];
      const cur = this.msgs[next];
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      prev.setAttribute('aria-hidden', 'true');
      prev.querySelector('a')?.setAttribute('tabindex', '-1');
      cur.classList.remove('is-leaving');
      cur.classList.add('is-active');
      cur.removeAttribute('aria-hidden');
      cur.querySelector('a')?.removeAttribute('tabindex');
      setTimeout(() => prev.classList.remove('is-leaving'), 500);
      this.classList.add('is-switching');
      setTimeout(() => this.classList.remove('is-switching'), 300);
      this.index = next;
    }
  });
}
